import React from 'react';
import { functionTexts } from '../contexts/Lang1K';

function Product1KFunction({ lang = 'ko', isMobile = false }) {
  return (
    <div
      style={{
        width: '100vw',
        maxWidth: '100vw',
        background: '#3a3570',
        borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        padding: isMobile ? '0 10px' : '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}
    >
      <span style={{
        fontSize: isMobile ? '1.6rem' : '2rem',
        fontWeight: 700,
        color: '#fff', // 글씨 색을 흰색으로 변경
        marginBottom: isMobile ? 12 : 16,
        paddingLeft: isMobile ? 20 : 40,
        paddingRight: isMobile ? 20 : 0,
        paddingTop: isMobile ? 20 : 28,
        display: 'block',
        lineHeight: 1.3,
        textAlign: 'center', // 가운데 정렬 추가
        width: '100%'        // 부모 div 기준으로 가운데 정렬 적용
      }}>
        {functionTexts.title[lang]}
      </span>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: isMobile ? '24px' : '32px',
          width: isMobile ? '100%' : '75%',
          padding: isMobile ? '20px 20px 32px 20px' : '32px 40px 40px 40px',
          boxSizing: 'border-box',
          margin: '0 auto'
        }}
      >
        {/* 1번 박스 */}
        <div style={{
          background: '#F5F6FA',
          borderRadius: 10,
          boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
          padding: isMobile ? '24px 20px' : '32px 24px',
          fontSize: isMobile ? '1.1rem' : '1.2rem',
          fontWeight: 600,
          color: '#29225C',
          minHeight: isMobile ? 'auto' : 120,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          textAlign: 'left'
        }}>
          <div style={{fontWeight: 800, fontSize: isMobile ? '1.4rem' : '1.7rem', marginBottom: isMobile ? 12 : 16, color: '#09225C'}}>
            {functionTexts.verify.title[lang]}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              width: '100%',
              gap: isMobile ? 16 : 24,
              alignItems: 'flex-start'
            }}
            className="box-row"
          >
            <div style={{flex: isMobile ? 'none' : 1, width: isMobile ? '100%' : 'auto', fontWeight: 400, fontSize: isMobile ? '0.95rem' : '1rem', color: '#444', whiteSpace: 'pre-line', marginBottom: isMobile ? 16 : 0}}>
              {functionTexts.verify.desc[lang]}
            </div>
            <div style={{flex: isMobile ? 'none' : 1, width: isMobile ? '100%' : 'auto', display: 'flex', justifyContent: 'center', alignItems: 'flex-start'}}>
              <iframe
                src="https://player.vimeo.com/video/846348024"
                width="100%"
                height={isMobile ? "200" : "360"}
                style={{borderRadius: 8, background: '#000', maxWidth: isMobile ? '100%' : 600, border: 'none'}}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="1Kosmos Verify 소개"
              ></iframe>
            </div>
          </div>
        </div>
        {/* 2번 박스 */}
        <div style={{
          background: '#F5F6FA',
          borderRadius: 10,
          boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
          padding: isMobile ? '24px 20px' : '32px 24px',
          fontSize: isMobile ? '1.1rem' : '1.2rem',
          fontWeight: 600,
          color: '#29225C',
          minHeight: isMobile ? 'auto' : 120,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          textAlign: 'left'
        }}>
          <div style={{fontWeight: 800, fontSize: isMobile ? '1.4rem' : '1.7rem', marginBottom: isMobile ? 12 : 8, color: '#09225C'}}>
            {functionTexts.workforce.title[lang]}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              width: '100%',
              gap: isMobile ? 16 : 24,
              alignItems: 'flex-start'
            }}
            className="box-row"
          >
            <div style={{flex: isMobile ? 'none' : 1, width: isMobile ? '100%' : 'auto', fontWeight: 400, fontSize: isMobile ? '0.95rem' : '1rem', color: '#444', whiteSpace: 'pre-line', marginBottom: isMobile ? 16 : 0}}>
                {functionTexts.workforce.desc[lang]}
            </div>
            <div style={{flex: isMobile ? 'none' : 1, width: isMobile ? '100%' : 'auto', display: 'flex', justifyContent: 'center', alignItems: 'flex-start'}}>
              <iframe
                src="https://player.vimeo.com/video/721553613"
                width="100%"
                height={isMobile ? "200" : "360"}
                style={{borderRadius: 8, background: '#000', maxWidth: isMobile ? '100%' : 600, border: 'none'}}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="1Kosmos Workforce 소개"
              ></iframe>
            </div>
          </div>          
        </div>
        {/* 3번 박스 */}
        <div style={{
          background: '#F5F6FA',
          borderRadius: 10,
          boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
          padding: isMobile ? '24px 20px' : '32px 24px',
          fontSize: isMobile ? '1.1rem' : '1.2rem',
          fontWeight: 600,
          color: '#29225C',
          minHeight: isMobile ? 'auto' : 120,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          textAlign: 'left'
        }}>
          <div style={{fontWeight: 800, fontSize: '1.7rem', marginBottom: 8, color: '#09225C'}}>
            {functionTexts.customer.title[lang]}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              width: '100%',
              gap: isMobile ? 16 : 24,
              alignItems: 'flex-start'
            }}
            className="box-row"
          >
            <div style={{flex: 1, fontWeight: 400, fontSize: isMobile ? '0.95rem' : '1rem', color: '#444', whiteSpace: 'pre-line'}}>
              {functionTexts.customer.desc[lang]}
             </div>
            <div style={{flex: isMobile ? 'none' : 1, width: isMobile ? '100%' : 'auto', display: 'flex', justifyContent: 'center', alignItems: 'flex-start'}}>
              <iframe
                src="https://player.vimeo.com/video/766606185"
                width="100%"
                height={isMobile ? "200" : "360"}
                style={{borderRadius: 8, background: '#000', maxWidth: isMobile ? '100%' : 600, border: 'none'}}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="1Kosmos Workforce 소개"
              ></iframe>
            </div>
          </div>        
        </div>
        {/* 4번 박스 */}
        <div style={{
          background: '#F5F6FA',
          borderRadius: 10,
          boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
          padding: isMobile ? '24px 20px' : '32px 24px',
          fontSize: isMobile ? '1.1rem' : '1.2rem',
          fontWeight: 600,
          color: '#29225C',
          minHeight: isMobile ? 'auto' : 120,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          textAlign: 'left'
        }}>
          <div style={{fontWeight: 800, fontSize: '1.7rem', marginBottom: 8, color: '#09225C'}}>
            {functionTexts.csp.title[lang]}
            </div>
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              width: '100%',
              gap: isMobile ? 16 : 24,
              alignItems: 'flex-start'
            }}
            className="box-row"
          >
            <div style={{flex: 1, fontWeight: 400, fontSize: isMobile ? '0.95rem' : '1rem', color: '#444', whiteSpace: 'pre-line'}}>
              {functionTexts.csp.desc[lang]}
              </div>
            <div style={{flex: isMobile ? 'none' : 1, width: isMobile ? '100%' : 'auto', display: 'flex', justifyContent: 'center', alignItems: 'flex-start'}}>
              <img
                src={require('../assets/images/1kosmos/fedramp.png')}
                alt="FedRAMP High"
                style={{maxWidth: isMobile ? 180 : 240, height: 'auto', borderRadius: 8, background: '#fff', display: 'block'}}
              />
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default Product1KFunction;